export const drawerComponentIds = {
  DrawerHeader: 'DrawerHeader',
  DrawerBody: 'DrawerBody',
  DrawerFooter: 'DrawerFooter',
  Drawer: 'Drawer',
};
